export default __webpack_public_path__ + "static/media/initiative-1.0bc9a33e.avif";